import '../Imports/facebookSDK'
import {enum_projectEnv_s} from "../../../functions/src/shareCode/Share_S_Enum";
import {gv_fun_env} from "../../../functions/src/shareCode/Share_Ass_GlobalVariable";

let initFacebook_b = false
let loginResponse_o = null

// facebook_init
const facebook_init = () => {

    if (initFacebook_b === false) {
        initFacebook_b = true
        FB.init({
            // appId: gv_fun_env.currentProject_e !== enum_projectEnv_s.tq_pro ? '600697987950990' : '1721799897927941',
            appId: gv_fun_env.currentProject_e !== enum_projectEnv_s.tq_pro ? '600697987950990' : '478717812576433',
            autoLogAppEvents: true,
            xfbml: true,
            version: 'v12.0'
        });
    }
}

// createScript
const createScript = () => {
    return new Promise((resolve, reject) => {
        const el = document.getElementById('auth_facebook_script_id');
        if (!el) {
            let gplatformScript = document.createElement('script')
            gplatformScript.setAttribute('src', 'https://connect.facebook.net/en_US/sdk.js')
            gplatformScript.setAttribute("async", true)
            gplatformScript.setAttribute("defer", "defer")
            gplatformScript.setAttribute("crossorigin", "anonymous")
            gplatformScript.setAttribute("id", "auth_facebook_script_id")
            document.head.appendChild(gplatformScript);
        }
        resolve();
    });
}

// facebook_login_fp
export const facebook_login_fp = () => {

    return new Promise((resolve,reject) =>{
        facebook_init()

        // if(loginResponse_o != null){
        //     resolve(loginResponse_o)
        // }else{
        FB.login((response) => {
            loginResponse_o = response
            resolve(loginResponse_o)
        }, {scope: 'public_profile, email'});
        // }
    }).then(loginResponse_o => {

        if(loginResponse_o.authResponse == null){
            throw enum_loginErrors.popup_closed_by_user
        }else{
            return loginResponse_o.authResponse.accessToken
        }
    })

}

export const facebook_share = (url_s, cb_f) => {
    facebook_init()
    FB.ui({
        method  : 'share',
        href    : url_s
    }, (response) => {
        cb_f(response)
    });
}

export const facebook_share_open_graph = () => {
    FB.ui({
        method: 'share_open_graph',
        action_type: 'og.likes',
        action_properties: JSON.stringify({
            object:'https://developers.facebook.com/docs/javascript/examples',
        })
    }, function(response){
        // Debug response (optional)
        console.log(response);
    });
}

export const facebook_share_image = ({quote_s, hashtag_s, fileUrl_s, cb_f}) => {

    facebook_init()
    FB.ui({
        method          : 'share',
        mobile_iframe   : true,
        quote           : quote_s ,
        hashtag         : hashtag_s,
        href            : fileUrl_s,
        url             : fileUrl_s,
    }, (response) => {
        console.log(response)
        cb_f()
    });

}

